import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsMarkUnmarkJobAsNeedsPlanningAsap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForToggleMarkJobAsNeedsPlanningAsap: "/api/v1/portal/jobs/mark-as/toggle/needs-planning-asap/",
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  toggleMarkJobAsNeedsPlanningAsap() {
    return fetch(
      this.state.apiUrlForToggleMarkJobAsNeedsPlanningAsap+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
      }
    );
  }

  render() {
    return(
      <span> {(this.state.data.needs_planning_asap === 0) ?
        <p>Job doesn't need to be planned ASAP<br />
          <button
            className="btn btn-lg btn-dark job-row-highlighter-option-cyan"
            title={"Toggle Mark Job as: NEEDS TO BE PLANNED "+
            "ASAP DATED TODAY OR TOMORROW"}
            onClick={(e) => this.toggleMarkJobAsNeedsPlanningAsap(e)}
          >
            Mark Job As Needs to be Planned ASAP
          </button>
        </p>
        :
        <p>
          <button
            className="btn btn-lg btn-cyan">
            Job needs to be planned ASAP
          </button>&nbsp;
          <button
            className="btn btn-lg btn-dark job-row-highlighter-option-cyan"
            title={"Toggle Mark Job as: NEEDS TO BE PLANNED "+
            "ASAP DATED TODAY OR TOMORROW"}
            onClick={(e) => this.toggleMarkJobAsNeedsPlanningAsap(e)}
          >
            <i className="fa fa-undo"></i>&nbsp;
            Unmark Job As Needs to be Planned ASAP
          </button>
        </p>
      }
    </span>
    )
  }
}